import { Injectable } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BreakpointService {

  constructor(private readonly breakpointObserver: BreakpointObserver) { }

  isMobile(): Observable<boolean> {
    return this.breakpointObserver.observe(['(max-width: 767px)'])
      .pipe(map((breakpoint: BreakpointState) => breakpoint.matches));
  }
}
